import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_LUXON_DATE_FORMATS } from '@angular/material-luxon-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginator } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Event, MY_DATE_FORMATS } from '../../../domain/registrator';
import { EventService } from '../../../services/event.service';

@Component({
  selector: 'app-select-event',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatRadioModule,
    MatTableModule,
    MatCardModule,
    MatListModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginator,
    MatSortModule,
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_DATE_FORMATS,
    },
  ],
  templateUrl: './select-event.component.html',
  styleUrl: './select-event.component.scss'
})
export class SelectEventComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly eventService = inject(EventService);
  private readonly cdr = inject(ChangeDetectorRef);

  eventListItems: Event[] = [];
  eventsDataSource: MatTableDataSource<Event> = new MatTableDataSource();
  pageSize: number = 10;
  pageIndex: number = 0;
  showFirstLastButtons: boolean = true;
  pageSizeOptions = [5, 10, 25, 100];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  columnsToDisplay = ['shortName', 'name', 'date', 'endDate', 'location', 'freeEvent'];


  constructor() {
  }

  ngOnInit(): void {
    this.eventService.events.subscribe((x) => {
      this.eventListItems = x;
      this.eventsDataSource.data = x;
      let s = sessionStorage.getItem('eventsListPageSize');
      if (s) {
        let page = parseInt(s);
        if (!isNaN(page)) {
          if (this.pageSizeOptions.includes(page)) {
            // console.log(`setting pagesize to ${s}`);
            this.pageSize = page;
          }
        }
      }
      s = sessionStorage.getItem('eventsListCurrentPage');
      if (s) {
        let page = parseInt(s);
        if (!isNaN(page)) {
          if ((page > 0) && (page < Math.ceil(this.eventListItems.length / this.pageSize))) {
            // console.log(`jumping to page ${s}`);
            this.pageIndex = page;
          }
        }
      }
    });
  }

  ngAfterViewInit() {
    this.eventsDataSource.paginator = this.paginator;
    this.eventsDataSource.sort = this.sort;
    this.sort!.active = 'date';  // Default sorting column
    this.sort!.direction = 'asc'; // Default order (ascending)        
    this.cdr.detectChanges(); // Trigger change detection to update the view
  }

  ngOnDestroy(): void {
  }

  gotoRegistration(event: Event) {
    this.router.navigate(['/admin', 'events', event.shortName]);
  }
}
